import React, { useState, useEffect } from "react";
import DataTable from "../components/DataTable";
import SnackbarAlert from "../components/SnackbarAlert";
import { Box, Button, IconButton, Tooltip, Typography, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions, Select, MenuItem } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
import noImage from "../assets/noimage.png";
import CloseIcon from "@mui/icons-material/Close";
export default function BannerManagement() {
    const [dataSource, setDataSource] = useState([]);
    const [preview, setPreview] = useState(null);
    const [type, setType] = useState();
    const [image, setImage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [editState, setEditState] = useState(null);
    const [snackbar, setSnackbar] = useState(false);
    const [message, setMessage] = useState("");
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    useEffect(() => {
        fetchMainCategory();
    }, []);
    const fetchMainCategory = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "banners";
            const response = await makeRequest("get", url);
            if (response) {
                setDataSource(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const handleImageChange = async (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview(reader.result);
            };
            reader.readAsDataURL(file);
            const formData = new FormData();
            formData.append('file', file);
            try {
                setLoading(true);
                const response = await fetch(webEndPoint + 'upload', {
                    method: 'POST',
                    body: formData,
                });
                const data = await response.text();
                setImage(data);
                setLoading(false);
            } catch (error) {
                setMessage('Error during file upload:');
                setSnackbar(true);
                setLoading(false);
            }
        }
    };
    const handleAdd = () => {
        setEditState(null);
        setOpenModal(true);
    };
    const handleEdit = (banner) => {
        setEditState(banner);
        setPreview(banner.image_url);
        setType(banner.image_type);
        setOpenModal(true);
    };
    const handleSave = async () => {
        if (!preview) {
            setMessage("Banner Image are Required");
            setSnackbar(true);
            return;
        }
        setLoading(true);
        try {
            if (editState) {
                const categoryEditData = {
                    image_type: type,
                    image_url: image ? image : preview
                };
                try {
                    let url = webEndPoint + "banners/" + editState.rfId;
                    const response = await makeRequest("put", url, categoryEditData);
                    if (response) {
                        setLoading(false);
                        setMessage("Banner Image Updated Successfully");
                    }
                } catch (err) {
                    if (err?.message) {
                        setMessage(err.message);
                    } else {
                        setMessage("Something went wrong");
                    }
                } finally {
                    setLoading(false);
                }
            } else {
                const categoryAddData = {
                    image_type: type,
                    image_url: image
                };
                try {
                    let url = webEndPoint + "banners";
                    const response = await makeRequest("post", url, categoryAddData);
                    if (response) {
                        setLoading(false);
                        setMessage("Banner Image Added Successfully");
                    }
                } catch (err) {
                    if (err?.message) {
                        setMessage(err.message);
                    } else {
                        setMessage("Something went wrong");
                    }
                } finally {
                    setLoading(false);
                }
            }
            setDataSource([]);
            fetchMainCategory();
            setSnackbar(true);
            setOpenModal(false);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const handleClose = () => {
        setOpenModal(false);
    };
    const handlePreview = (img) => {
        setPreviewImage(img);
        setPreviewOpen(true);
    };
    const handleClosePreview = () => {
        setPreviewOpen(false);
        setPreviewImage(null);
    };
    const columns = ["S.No", "Banner", "Type", "Action"];
    const rows = dataSource.map((banner, i) => [i + 1, <img src={banner?.image_url || noImage} alt="banner" onClick={() => handlePreview(banner?.image_url || noImage)} style={{ width: 150, height: 60, objectFit: "cover", borderRadius: 5, cursor: "pointer", transition: "0.3s" }} onMouseOver={e => e.currentTarget.style.transform = "scale(1.05)"} onMouseOut={e => e.currentTarget.style.transform = "scale(1)"} />,
    banner.image_type,
    <Box>
        <Tooltip title="Edit Banner / Measurement">
            <IconButton color="primary" onClick={() => handleEdit(banner)}>
                <EditIcon />
            </IconButton>
        </Tooltip>
    </Box>
    ]);
    return (
        <Box sx={{ position: "relative" }}>
            {loading && (
                <Box sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(255,255,255,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }}>
                    <CircularProgress />
                </Box>
            )}
            <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>Banner</Typography>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
                <Button variant="contained" startIcon={<AddIcon />} onClick={handleAdd}>Add Banner</Button>
            </Box>
            <DataTable columns={columns} rows={rows} loading={false} />
            <Dialog open={openModal} onClose={handleClose} fullWidth maxWidth="sm">
                <DialogTitle> {editState ? "Edit Banner" : "Add Banner"}</DialogTitle>
                <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
                    <Box>
                        <Typography variant="subtitle2" sx={{ mb: 1 }}>Select Type</Typography>
                        <Select value={type} onChange={(e) => setType(e.target.value)} displayEmpty fullWidth>
                            <MenuItem value="" disabled>Select Type</MenuItem>
                            <MenuItem value="Banner">Banner</MenuItem>
                            <MenuItem value="Second Page Banner">Second Page Banner</MenuItem>
                            <MenuItem value="Measurement">Measurement</MenuItem>
                        </Select>
                    </Box>
                    <Box>
                        <Typography variant="subtitle2" sx={{ mb: 1 }}>Upload Image </Typography>
                        <Button variant="contained" component="label"> Choose File
                            <input type="file" accept="image/*" hidden onChange={handleImageChange} />
                        </Button>
                        {preview && (
                            <Box sx={{ mt: 2 }}>
                                <Typography variant="caption">Preview:</Typography>
                                <Box component="img" src={preview} alt="preview" sx={{ width: "100%", height: 150, objectFit: "cover", mt: 1, borderRadius: 1 }} />
                            </Box>
                        )}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button variant="contained" onClick={handleSave}>Save</Button>
                </DialogActions>
            </Dialog>
            <Dialog open={previewOpen} onClose={handleClosePreview} maxWidth="md">
                <DialogTitle>
                    Image Preview
                    <IconButton onClick={handleClosePreview} sx={{ position: "absolute", right: 10, top: 10 }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <img src={previewImage} alt="Preview" style={{ width: "100%", borderRadius: 10 }} />
                </DialogContent>
            </Dialog>
            <SnackbarAlert open={snackbar} setOpen={setSnackbar} message={message} />
        </Box>
    );
}